import { createRouter, createWebHistory } from "vue-router";
import InteractiveMap from "../components/InteractiveMap.vue";
import LiveSearch from "../components/LiveSearch.vue";
import VacationsCalendar from "../components/VacationsCalendar.vue";
import ImageUpload from "../components/info-base/ImageUpload.vue";
import ImageUploadEdit from "../components/info-base/ImageUploadEdit.vue";
import CompanyVisitQr from "../components/bcard/CompanyVisitQr.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/info-base",
            name: "InteractiveMap",
            component: InteractiveMap,
        },
        {
            path: "/search",
            name: "LiveSearch",
            component: LiveSearch,
        },
        {
            path: "/vacations",
            name: "VacationsCalendar",
            component: VacationsCalendar,
        },
        {
            path: "/:slug/create",
            name: "ImageUpload",
            component: ImageUpload,
        },
        {
            path: "/:slug/:id/edit",
            name: "ImageUploadEdit",
            component: ImageUploadEdit,
        },
        {
            path: "/bcard/company/qr",
            name: "CompanyVisitQr",
            component: CompanyVisitQr,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                el: to.hash,
            };
        } else {
            return { top: 0 };
        }
    },
});

export default router;
